export default __webpack_public_path__ + "static/3-6165181d3d0ecbfa0d5a74cf6ecac46f.jpeg";